import React from 'react';

import NotFoundPage from 'src/routes/404';

/**
 * Authenticated catch-all for URLs that are not currently registered in the
 * active route table. Always renders the not-found page.
 */
const ExperienceFallbackRoute = () => <NotFoundPage />;

export default ExperienceFallbackRoute;
